module.exports = __webpack_public_path__ + "static/media/icon-voc-dark.025f43d5.svg";